import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import defer from 'lodash/defer';
import UrlParse from 'url-parse';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-left-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import ProductItem from '~/components/library/Product/ProductItem.vue';
var tns = {};

if (process.browser) {
  // eslint-disable-next-line
  tns = require('exports-loader?tns!../../../../node_modules/tiny-slider/dist/min/tiny-slider.js');
}

export default {
  name: 'GlobalCategoryProductsCarousel',
  components: {
    ProductItem: ProductItem
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;

      var path = new UrlParse((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.button_url) != null ? _ref7.url : _ref7 : _ref7 : _ref7).pathname;
      return {
        title: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? (_ref6 = _ref6.title) != null ? (_ref6 = _ref6[0]) != null ? _ref6.text : _ref6 : _ref6 : _ref6 : _ref6) || '',
        button: {
          text: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.button_text : _ref5 : _ref5) || '',
          url: path || '',
          tracking: {
            data: {
              event_category: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.event_category : _ref4 : _ref4) || '',
              event_action: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_action : _ref3 : _ref3) || '',
              event_label: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_label : _ref2 : _ref2) || ''
            }
          }
        },
        arg: {
          url: path || '',
          limit: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.limit : _ref : _ref) || 10
        }
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    defer(function () {
      if (!_this.catalog || !_this.catalog.category || !_this.catalog.category.products || !_this.catalog.category.products.length) return;
      tns({
        container: '.product-slider',
        controlsContainer: '.customize-controls',
        items: 1.5,
        gutter: 20,
        loop: false,
        nav: false,
        speed: 400,
        responsive: {
          576: {
            items: 2
          },
          768: {
            items: 3
          },
          1111: {
            items: 4
          }
        }
      });
    });
  },
  methods: {
    trackingProduct: function trackingProduct(product, index) {
      return {
        fn: 'product_list_click',
        data: {
          product_id: product.reference,
          position: index,
          category_click: ''
        }
      };
    }
  }
};